<template>
  <div class="noselect">
    <b-container fluid class="header">
      <b-row>
        <b-col cols="12">
          <img class="p-3 logo mx-auto d-block" src="../../assets/img/easytick_color.png">
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-row>
        <b-col md="6" offset-md="3" xl="4" offset-xl="4" class="change-ticket-owner">
          <h1 class="text-center my-4">Alterar titularidade de ingresso digital</h1>

          <b-col v-if="!newTicket.show">
            <b-form @submit="onSubmit">
              <h2 class="mb-3">Identificação do ingresso</h2>
              <!-- Código de segurança -->
              <b-form-group
                label="Código de segurança:"
                label-for="input-ticket-code"
                description="Informe o código de segurança do ingresso"
              >
                <b-form-input
                  id="input-ticket-code"
                  v-model="formChanger.ticket.code"
                  type="text"
                  v-mask="'hhhh hhhh hhhh hhhh hhhh hhhh hhhh hhhh'"
                  autocomplete="off"
                  :autofocus="true"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- Número ingresso -->
              <b-form-group
                label="Número do ingresso:"
                label-for="input-ticket-number"
                description="Informe o número do ingresso"
              >
                <b-form-input
                  id="input-ticket-number"
                  v-model.number="formChanger.ticket.number"
                  type="number"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- CPF do titular atual -->
              <b-form-group
                label="CPF do titular atual:"
                label-for="input-owner-document"
                description="Informe o CPF do titular atual"
              >
                <b-form-input
                  id="input-owner-document"
                  v-model="formChanger.oldOwner.document"
                  type="text"
                  v-mask="'###.###.###-##'"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>

              <h2 class="mb-3">Dados do novo titular</h2>
              <!-- Nome novo titular -->
              <b-form-group
                label="Nome do novo titular:"
                label-for="input-new-owner-name"
                description="Informe o nome do novo titular"
              >
                <b-form-input
                  id="input-new-owner-name"
                  v-model="formChanger.newOwner.name"
                  type="text"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- CPF novo titular -->
              <b-form-group
                label="CPF do novo titular:"
                label-for="input-new-owner-document"
                description="Informe o CPF do novo titular"
              >
                <b-form-input
                  id="input-new-owner-document"
                  v-model="formChanger.newOwner.document"
                  type="text"
                  v-mask="'###.###.###-##'"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- Telefone novo titular -->
              <b-form-group
                label="Telefone do novo titular:"
                label-for="input-new-owner-phone"
                description="Informe o telefone do novo titular"
              >
                <b-form-input
                  id="input-new-owner-phone"
                  v-model="formChanger.newOwner.phone"
                  type="text"
                  v-mask="'(##) #####-####'"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>

              <b-button type="submit" variant="primary">Validar e alterar titularidade</b-button>

              <span class="d-block my-3 captcha font-weight-lighter text-muted">Esta página é protegida pelo reCAPTCHA e está sujeita à <a href="https://www.google.com/policies/privacy/" target="_blank">Política de privacidade</a> e aos <a href="https://www.google.com/policies/terms/" target="_blank">Termos de serviço</a> do Google.</span>
            </b-form>
          </b-col>

          <b-col v-else>
              <b-alert variant="success" show class="text-center my-4">Titularidade alterada com sucesso!</b-alert>

              <p>Salve a imagem do ingresso em seu dispositivo.<br>Opções:</p>
              <ul>
                <li class="mb-3">Clique no botão azul <i>Salvar ingresso</i>; ou</li>
                <li class="mb-3">Clique com o direito do mouse em selecione <i>Salvar imagem como...</i>; ou</li>
                <li>Toque e segure na imagem.</li>
              </ul>

              <div class="text-center my-4">
                <b-button variant="primary" @click="saveNewTicket">Salvar ingresso</b-button>
                <b-button class="ml-4" variant="danger" @click="changeAnotherTicket">Alterar outro</b-button>
              </div>
              <b-img class="mb-4 select-auto" center thumbnail rounded :src="newTicket.src"></b-img>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'

export default {
  name: 'PublicIdChangeOwner',
  data () {
    return {
      newTicket: {
        show: false,
        src: '',
        filename: '',
        key_src: 'new_ticket_image_src',
        key_filename: 'new_ticket_image_filename'
      },
      formChanger: {
        ticket: {
          code: '',
          number: ''
        },
        oldOwner: {
          document: ''
        },
        newOwner: {
          name: '',
          document: '',
          phone: ''
        }
      }
    }
  },
  created () {
    let previousTicketSrc = localStorage.getItem(this.newTicket.key_src)
    let previousTicketFilename = localStorage.getItem(this.newTicket.key_filename)

    if (previousTicketSrc !== null && previousTicketFilename !== null) {
      this.newTicket.show = true
      this.newTicket.src = previousTicketSrc
      this.newTicket.filename = previousTicketFilename
    }
  },
  methods: {
    async onSubmit (event) {
      this.$wait.start()
      event.preventDefault()
      await this.$recaptchaLoaded()
      let recaptcha = await this.$recaptcha('webapp_change_ticket_owner')

      let ticketCode = String(this.formChanger.ticket.code).replace(/\s/g, '')
      let oldOwnerDocument = String(this.formChanger.oldOwner.document).replace(/\D/g, '')

      let url = process.env.VUE_APP_URL_APP + `/b/tickets/${ticketCode}/${this.formChanger.ticket.number}/owners/${oldOwnerDocument}`
      let putData = {
        recaptcha: recaptcha,
        name: this.formChanger.newOwner.name,
        document: String(this.formChanger.newOwner.document).replace(/\D/g, ''),
        phone: String(this.formChanger.newOwner.phone).replace(/\D/g, ''),
        user_agent: navigator.userAgent,
      }

      try {
        let changeResponse = await this.$http.put(url, putData, {responseType: 'blob'})

        if (changeResponse.ok) {
          let blob = await changeResponse.blob()
          let filename = changeResponse.headers.get('x-filename')

          let reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = () => {
              this.newTicket.src = reader.result
              this.newTicket.filename = filename
              localStorage.setItem(this.newTicket.key_src, reader.result)
              localStorage.setItem(this.newTicket.key_filename, filename)
          }
          this.newTicket.show = true
          return
        }
      } catch (err) {
        alert(err.body.message)
      }
    },
    async changeAnotherTicket () {
      const action = await this.$bvModal.msgBoxConfirm(`Após confirmar essa ação o ingresso abaixo não será exibido novamente em nenhum momento.`, {
        title: 'Você salvou a imagem do ingresso?',
        okVariant: 'success',
        cancelVariant: 'danger',
        okTitle: 'Sim, salvei',
        cancelTitle: 'Não, quero voltar',
        centered: true,
        hideHeaderClose: false
      })

      if (action === false || !action) {
        return false
      }

      localStorage.removeItem(this.newTicket.key_src)
      localStorage.removeItem(this.newTicket.key_filename)
      this.newTicket.src = ''
      this.newTicket.filename = ''
      this.newTicket.show = false
    },
    saveNewTicket () {
      saveAs(this.newTicket.src, this.newTicket.filename)
    }
  }
}
</script>

<style lang="scss" scoped>
.change-ticket-owner {
  h1 {
    font-size: 23px;
    color: #1c4b57;
    font-weight: bold;
    text-transform: uppercase;
    background: #fff;
  }
  h2 {
    font-size: 18px;
    color: #205866;
    font-weight: bold;
    border-bottom: 1px solid #ececec;
  }
}
</style>
